/* LB fix 19-09-2026 (v3) — se carga desde snippets/meta-tags.liquid (antes que el JS grande del tema).
   A) Galería: el tema, nada más cargar, mueve la galería a la foto del color seleccionado (la 7, el gris) y se veía
      ese salto. Este script se ejecuta ANTES que el del tema y, durante el primer segundo y medio (o hasta que el
      usuario toque algo), cualquier intento de mover la galería la deja en la foto 1. Sin salto: la primera foto
      que se pinta es la 1. Al cambiar de color después, la galería va a la foto de ese color como siempre.
   B) Zoom: NO se toca el zoom del tema (tocar = 2x, dos dedos, arrastrar). Lo único que se añade: si la foto
      ampliada sale de la vista porque bajas la página, se cierra sola; y Escape la cierra. Nada más.
   C) 22-09-2026 — Abrigo Nube: mismo header blanco que Milo (logo e iconos FUERA de la foto, porque sus fotos llevan
      texto). Se reutiliza la clase lb-cabecera-blanca, cuyo CSS ya está probado en Milo. Para aplicarlo a otro producto,
      añadir su handle a la lista lbWhiteHeaderHandles. */
(function () {
  'use strict';

  /* ---------- C) header blanco (como Milo) en los productos de la lista ---------- */
  var lbWhiteHeaderHandles = ['abrigo-sudadera-oversize-con-capucha-mujer'];
  if (document.body && document.body.classList.contains('lb-product')) {
    var lbPath = window.location.pathname || '';
    for (var lbI = 0; lbI < lbWhiteHeaderHandles.length; lbI++) {
      if (lbPath.indexOf('/products/' + lbWhiteHeaderHandles[lbI]) !== -1) { document.body.classList.add('lb-cabecera-blanca'); break; }
    }
  }

  if (!document.body || !document.body.classList.contains('lb-product')) return;

  function gallery() { return document.querySelector('.product__media-list'); }
  var userTouched = false;
  function markTouched() { userTouched = true; }
  ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) { document.addEventListener(ev, markTouched, { passive: true, capture: true }); });

  /* ---------- A) la galería empieza en la foto 1 ---------- */
  function firstSlide(g) {
    return g.querySelector('.product__media-item[data-lb-original-slide="true"]') || g.querySelector('.product__media-item:not([data-lb-clone="true"])') || g.querySelector('.product__media-item');
  }
  function firstLeft(g) {
    var f = firstSlide(g);
    return f ? Math.max(0, f.offsetLeft - ((g.clientWidth - f.clientWidth) / 2)) : null;
  }
  function guardGallery() {
    var g = gallery();
    if (!g || g.__lbStartGuard) return;
    g.__lbStartGuard = true;
    var desc = Object.getOwnPropertyDescriptor(Element.prototype, 'scrollLeft');
    var active = true;
    if (desc && desc.set) {
      Object.defineProperty(g, 'scrollLeft', {
        configurable: true,
        get: function () { return desc.get.call(this); },
        set: function (v) {
          var t = (active && !userTouched) ? firstLeft(this) : null;
          desc.set.call(this, t !== null ? t : v);
        }
      });
    }
    var origScrollTo = g.scrollTo;
    g.scrollTo = function (a, b) {
      if (active && !userTouched) {
        var t = firstLeft(this);
        if (t !== null) { if (a && typeof a === 'object') a = Object.assign({}, a, { left: t }); else a = t; }
      }
      return origScrollTo.apply(this, arguments.length > 1 ? [a, b] : [a]);
    };
    function release() {
      active = false;
      try { delete g.scrollLeft; } catch (e) {}
      g.scrollTo = origScrollTo;
    }
    window.setTimeout(release, 1600);
    // Por si algo se colara: comprobación suave a los 400 y 1200 ms.
    [400, 1200].forEach(function (t) {
      window.setTimeout(function () {
        if (userTouched) return;
        var left = firstLeft(g);
        if (left !== null && Math.abs(desc.get.call(g) - left) > 2) { desc.set.call(g, left); try { g.dispatchEvent(new Event('scroll')); } catch (e) {} }
      }, t);
    });
  }

  /* ---------- B) cerrar el zoom solo si la foto ampliada sale de la vista ---------- */
  function zoomedItems() { return Array.prototype.slice.call(document.querySelectorAll('.product__media-item.lb-image-zoomed')); }
  function busy() { var g = gallery(); return !!(g && (g.dataset.lbProductPinching === 'true' || g.dataset.lbPanning === 'true')); }
  function closeZoom() {
    if (busy()) return;
    zoomedItems().forEach(function (item) {
      item.style.setProperty('--lb-zoom-transition', 'transform .18s cubic-bezier(.22, .61, .36, 1)');
      item.style.setProperty('--lb-zoom-scale', '1');
      item.classList.remove('lb-image-zoomed');
      window.setTimeout(function () {
        if (item.classList.contains('lb-image-zoomed')) return;
        ['--lb-zoom-x', '--lb-zoom-y', '--lb-zoom-tx', '--lb-zoom-ty', '--lb-zoom-scale', '--lb-zoom-transition'].forEach(function (p) { item.style.removeProperty(p); });
      }, 220);
    });
    if (!zoomedItems().length) document.body.classList.remove('lb-product-image-zoom-active');
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.target.classList.contains('lb-image-zoomed')) { io.unobserve(e.target); return; }
      if (e.intersectionRatio < 0.25) closeZoom();
    });
  }, { threshold: [0, 0.25, 0.5, 1] }) : null;
  var mo = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      var el = m.target;
      if (!el.classList || !el.classList.contains('product__media-item')) return;
      if (el.classList.contains('lb-image-zoomed')) { if (io) io.observe(el); }
      else if (io) io.unobserve(el);
    });
  });
  function armZoom() {
    var g = gallery();
    if (!g || g.dataset.lbZoomCloseReady === 'true') return;
    g.dataset.lbZoomCloseReady = 'true';
    mo.observe(g, { attributes: true, attributeFilter: ['class'], subtree: true });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); });

  function init() { guardGallery(); armZoom(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  window.addEventListener('load', armZoom, { once: true });
})();
